import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const reimburseApi = createApi({
  reducerPath: 'reimburseApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Reimburse', 'DetailCus'],
  endpoints: (builder) => ({
    getListReimburse: builder.query({
      query: (params) => ({
        url: NetWork.reimburse,
        method: GET,
        params: params
      }),
      // providesTags: (result: ReponseData2<{ rows: ReimburseType[] }>) =>
      //   result ? [{ type: 'Reimburse', id: 'LIST' }] : [])
      providesTags: (result) => (result ? [{ type: 'Reimburse', id: 'LIST' }] : [])
    }),
    getReimburseById: builder.query({
      query: (params: { reimburseId: number }) => ({
        url: NetWork.reimburseId(params.reimburseId),
        method: GET
      }),
      providesTags: (result) => (result ? [{ type: 'DetailCus', id: 'DETAIL' }] : [])
    }),
    addReimburse: builder.mutation({
      query: (data) => ({
        url: NetWork.reimburse,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'Reimburse', id: 'LIST' }]
    }),
    updateReimburse: builder.mutation({
      query: (data) => ({
        url: NetWork.reimburseId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'Reimburse', id: 'LIST' }]
    }),
    deleteReimburse: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.reimburse,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'Reimburse', id: 'LIST' }] // Vô hiệu hóa tag 'Reimburse' với id 'LIST' để gọi lại getListReimburse
      }),
      invalidatesTags: [{ type: 'Reimburse', id: 'LIST' }]
    }),
    changeStatusReimburse: builder.mutation({
      query: (data: { reimburseId: number; params: { isActive: boolean } }) => ({
        url: NetWork.reimburseId(data.reimburseId),
        method: PATCH,
        params: data.params
      })
    }),
    updateStatusApprovalReimburse: builder.mutation({
      query: (data: { id: number; params: { statusApproval: string; reasonCancel?: string } }) => ({
        url: NetWork.reimburseApproval(data.id),
        method: PUT,
        params: data.params
      }),
      invalidatesTags: [{ type: 'Reimburse', id: 'LIST' }]
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListReimburseQuery,
  useDeleteReimburseMutation,
  useAddReimburseMutation,
  useGetReimburseByIdQuery,
  useUpdateReimburseMutation,
  useChangeStatusReimburseMutation,
  useUpdateStatusApprovalReimburseMutation
} = reimburseApi
